import { useCallback, useEffect, useState } from 'react'
import { getCsrfToken } from '../../../utils/csrf'
import { AssetTotalTesouro, IndividualAssetTesouro } from '../../models/ModelInvestments'

export const useTesouroDashboard = () => {
  const [assetTotals, setAssetTotals] = useState<AssetTotalTesouro | null>(null)
  const [individualAssets, setIndividualAssets] = useState<IndividualAssetTesouro[]>([])
  const [exchangeRate, setExchangeRate] = useState<number>(5)
  const [showUSD, setShowUSD] = useState(false)
  const [isRecalculating, setIsRecalculating] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isInitialLoad, setIsInitialLoad] = useState(true)

  const fetchTesouroDashboardData = useCallback(async () => {
    try {
      if (isInitialLoad) {
        setIsLoading(true)
      }

      const csrfToken = await getCsrfToken()
      const response = await fetch('/api/investments/dashboard/tesouro-direto/', {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
      })
      
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

      const data = await response.json()
      
      if (data.success) {
        setAssetTotals(data.data.asset_totals)
        setIndividualAssets(data.data.individual_assets)
        setIsRecalculating(data.data.is_recalculating)
        
        if (data.data.exchange_rate) {
          const rate = parseFloat(data.data.exchange_rate)
          setExchangeRate(isNaN(rate) ? 5 : rate)
        }
      } else {
        console.error('Error fetching tesouro direto dashboard data:', data)
        setIsRecalculating(false)
      }
    } catch (error) {
      console.error('Error fetching tesouro direto dashboard data:', error)
      setIsRecalculating(false)
    } finally {
      if (isInitialLoad) {
        setIsLoading(false)
        setIsInitialLoad(false)
      }
    }
  }, [isInitialLoad])

  useEffect(() => {
    fetchTesouroDashboardData()
    
    const interval = setInterval(fetchTesouroDashboardData, 30000)
    return () => clearInterval(interval)
  }, [fetchTesouroDashboardData])

  return {
    assetTotals,
    individualAssets,
    exchangeRate,
    showUSD,
    setShowUSD,
    isRecalculating,
    isLoading,
    fetchTesouroDashboardData
  }
}